import sa from 'cl_sensorsdata'
import { setGoToUrl } from '@chengla_web/cl_newutil'
console.log(sa,'sa')
const isProduction = process.env.VUE_APP_ENV;
sa.init({
  server_url: setGoToUrl('trace',isProduction?.toString()) + '/g.gif',
  is_single_page: true,
  heatmap: {
    // 是否开启点击图，默认 default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭
    clickmap: 'default',
    scroll_notice_map: 'default',
    show_log:isProduction?.toString() == 'production',
    scroll_delay_time: 4000
  }
})
sa.registerPage({
  PlatformType: 'JSFD_h5Manage'
})
export default sa